const _jslib_isIE=document.all?true:false;
const _jslib_isNS=document.layers?true:false;
const _jslib_isNS6=document.getElementById&&!document.all?true:false;

export const getElementById = id => {

  if(_jslib_isIE) {
      return document.all[id];
  } else if(_jslib_isNS) {
      return document.layers[id];
  } else if (_jslib_isNS6) {
      return document.getElementById(id);
  }
  
  return null;
}

export const getWindowSize = () => {
  
  const w = window.innerWidth
    || document.documentElement.clientWidth
    || document.body.clientWidth
  const h = window.innerHeight
    || document.documentElement.clientHeight
    || document.body.clientHeight

  return {
    w: w,
    h: h,
    o:  w <= h ? 'portrait' : 'landscape'
  }
}